import { getApiBaseUrl } from './apiConfig';

/**
 * Monta a URL absoluta para exibir um arquivo de mídia (foto ou vídeo).
 * O backend devolve path relativo no storage (ex: `establishments/.../uuid.png`) ou
 * um path de endpoint já montado (ex: `/media/serve-my-photo` em `FindMeDto.photoUrl`).
 */
export function getMediaUrl(relativePath: string | undefined | null): string {
  if (!relativePath || typeof relativePath !== 'string') return '';
  const trimmed = relativePath.trim();
  const base = getApiBaseUrl().replace(/\/$/, '');

  if (trimmed.startsWith('/media/')) {
    return base ? `${base}${trimmed}` : trimmed;
  }

  const pathEnc = encodeURIComponent(trimmed);
  return base ? `${base}/media/serve?path=${pathEnc}` : `/media/serve?path=${pathEnc}`;
}
